import React from 'react';
import { Text, View } from '@react-pdf/renderer';

interface ComponentProps {
  label: string;
  value?: string | number;
  styles: {
    row: any;
    col1: any;
    col2: any;
    label: any;
  };
}

export const Row: React.FC<ComponentProps> = ({ styles, label, value }) => {
  return (
    <View style={styles.row}>
      <Text style={[styles.col1, styles.label]}>{label}:</Text>
      <Text style={styles.col2}>{value}</Text>
    </View>
  );
};
